module.exports = __webpack_public_path__ + "static/img/realLive.c4ede34.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/realLive.png
// module id = 1Yv8
// module chunks = 1